<template>
  <b-container class="nopads" fluid id="app">
      <router-view/>
  </b-container>
</template>

<script>
    import Vue from 'vue'
    import BootstrapVue from 'bootstrap-vue'
    import {app} from './main'
    import {languageMixin} from './mixins/LanguageMixin.js'
    import FairApi from "./modules/api";

    Vue.use(BootstrapVue)

    export default {
        name: 'App',
        mixins: [languageMixin],
        data() {
            return {
                locale: 'fi',
                user: null
            }
        },
        created: function () {
            this.locale = this.$store.state.locale
            if (!this.locale) {
                this.locale = 'fi' // customer req for fi despite browser lang this.getDefaultLanguage()
                this.$store.commit('storeLocale', this.locale)
            }
            FairApi.setHeader()
        },
        watch: {
            '$store.state.token': function (newToken, oldToken) {
                if (oldToken && !newToken) {
                    this.$store.commit('storeUser', null)
                    this.$store.commit('storeStripeAuthOrganization', null)
                    FairApi.setHeader()
                    this.$router.push({name: 'main-view'})
                }
            },
            locale(val) {
                app.$i18n.locale = val
                this.$store.commit('storeLocale', val)
            }
        },
        methods: {
            setFinnish: function () {
                this.locale = 'fi'
            },

            setEnglish: function () {
                this.locale = 'en'
            }
        }
    }
</script>
<style>
    @import '../node_modules/bootstrap/dist/css/bootstrap.css';
    @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
    @import "styles/style.css";
</style>
